import React from 'react'

function Team() {
  return (
    <section class="team-section-three" id="bridegrooms">
        <div class="auto-container">
            <div class="sec-title text-center">
            <span class="icon-divider-4"></span>
            <h2>Bridesmaids & Groomsmen</h2>
            </div>
            <div class="row">
                <div class="team-block-three col-lg-3 col-sm-6">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image wow zoomIn">
                        <a href="page-team-details.html"><img src="images/resource/team3-1.jpg" alt="Image" /></a>
                        </figure>
                        <div class="team3-frame"></div>
                    </div>
                    <div class="content-box">
                        <h6 class="title"><a href="page-bride-and-groom.html">Marina Alex</a></h6>
                        <span class="designation">Bridesmaid</span>
                    </div>
                    </div>
                </div>

                <div class="team-block-three col-lg-3 col-sm-6">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image wow zoomIn">
                        <a href="page-team-details.html"><img src="images/resource/team3-2.jpg" alt="Image" /></a>
                        </figure>
                        <div class="team3-frame"></div>
                    </div>
                    <div class="content-box">
                        <h6 class="title"><a href="page-bride-and-groom.html">Marina Alex</a></h6>
                        <span class="designation">Bridesmaid</span>
                    </div>
                    </div>
                </div>

                <div class="team-block-three col-lg-3 col-sm-6">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image wow zoomIn">
                        <a href="page-team-details.html"><img src="images/resource/team3-3.jpg" alt="Image" /></a>
                        </figure>
                        <div class="team3-frame"></div>
                    </div>
                    <div class="content-box">
                        <h6 class="title"><a href="page-bride-and-groom.html">Marina Alex</a></h6>
                        <span class="designation">Bridesmaid</span>
                    </div>
                    </div>
                </div>
                <div class="team-block-three col-lg-3 col-sm-6">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image wow zoomIn">
                        <a href="page-team-details.html"><img src="images/resource/team3-4.jpg" alt="Image" /></a>
                        </figure>
                        <div class="team3-frame"></div>
                    </div>
                    <div class="content-box">
                        <h6 class="title"><a href="page-bride-and-groom.html">Marina Alex</a></h6>
                        <span class="designation">Bridesmaid</span>
                    </div>
                    </div>
                </div>
                <div class="team-block-three col-lg-3 col-sm-6">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image wow zoomIn">
                        <a href="page-team-details.html"><img src="images/resource/team3-5.jpg" alt="Image" /></a>
                        </figure>
                        <div class="team3-frame"></div>
                    </div>
                    <div class="content-box">
                        <h6 class="title"><a href="page-bride-and-groom.html">Marina Alex</a></h6>
                        <span class="designation">Groomsmen</span>
                    </div>
                    </div>
                </div>
                <div class="team-block-three col-lg-3 col-sm-6">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image wow zoomIn">
                        <a href="page-team-details.html"><img src="images/resource/team3-6.jpg" alt="Image" /></a>
                        </figure>
                        <div class="team3-frame"></div>
                    </div>
                    <div class="content-box">
                        <h6 class="title"><a href="page-bride-and-groom.html">Marina Alex</a></h6>
                        <span class="designation">Groomsmen</span>
                    </div>
                    </div>
                </div>

                <div class="team-block-three col-lg-3 col-sm-6">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image wow zoomIn">
                        <a href="page-team-details.html"><img src="images/resource/team3-7.jpg" alt="Image" /></a>
                        </figure>
                        <div class="team3-frame"></div>
                    </div>
                    <div class="content-box">
                        <h6 class="title"><a href="page-bride-and-groom.html">Marina Alex</a></h6>
                        <span class="designation">Groomsmen</span>
                    </div>
                    </div>
                </div>

                <div class="team-block-three col-lg-3 col-sm-6">
                    <div class="inner-box">
                    <div class="image-box">
                        <figure class="image wow zoomIn">
                        <a href="page-team-details.html"><img src="images/resource/team3-8.jpg" alt="Image" /></a>
                        </figure>
                        <div class="team3-frame"></div>
                    </div>
                    <div class="content-box">
                        <h6 class="title"><a href="page-bride-and-groom.html">Marina Alex</a></h6>
                        <span class="designation">Groomsmen</span>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Team